import CRUDActions from "./CRUD";
import {Promotion} from "../api/promotion";

export class PromotionCRUDActions extends CRUDActions {
  prefix = 'promotion';

  get _model() {
    return Promotion;
  }

  /**
   *
   * @param {News} model
   * @returns {function(*)}
   */
  publish(model) {
    return async (dispatch) => {
      dispatch({
        type: this.saveItemAction,
        id: model.id
      });
      try {
        let updatedModel = await model.publish();

        dispatch({
          type: this.saveItemFinishedSuccessAction,
          model: updatedModel
        });

        return true;
      }
      catch (error) {
        dispatch({
          type: this.saveItemFinishedFailAction,
          error
        });
        return false;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/actions/promotion.ts